import AdditionalWorkout from './AdditionalWorkout';

export default AdditionalWorkout;
